<script>
  import {onDestroy, onMount} from 'svelte';
  import {writable} from 'svelte/store';
  import editorStore from '../../editor.store';
  import {getSvgColors} from './svg-utils';
  import SvgColorPicker from './SvgColorPicker.svelte';
  export let desc;
  let counter = 0;
  let colors;
  let active;
  let colorsStore = writable([]);
  const unmount = editorStore.subscribe(store => {
    if (active == store.activeComponent) return;
    else if (store.activeComponent) colorsStore.set(null);
    active = store.activeComponent;
    if (active) {
      colors = null;
      counter++;
      colors = getSvgColors(active);
      colorsStore.set(getSvgColors(active));
    }
  });
  const onChanged = e => {};
  onMount(() => {
    counter++;
  });
  onDestroy(unmount);
</script>

{#if $colorsStore}
  {#if $colorsStore.stroke}
    <SvgColorPicker color={$colorsStore.stroke} />
  {/if}
  {#if $colorsStore.fill}
    <SvgColorPicker color={$colorsStore.fill} />
  {/if}
  {#if $colorsStore.stops}
    <SvgColorPicker color={$colorsStore.stops} />
  {/if}
{/if}
